import { z } from 'zod';
import { AuditSchema } from './../settings/audit-schema';
import { EmployeeSchema } from '../owner/employee-schema';

export const PayrollCycleStatusSchema = z.enum([
  'draft',      // En preparación
  'reviewing',  // Esperando pre-aprobación del manager
  'approved',   // Aprobado pero no pagado
  'paid',       // Ejecucción completa en el Ledger
  'cancelled',
]);

export const PayrollEmployeeReportSchema = z.object({
  employeeId: z.string(),
  name: z.string(),
  idNumber: z.string().optional(), // Snapshot para el recibo
  hiringDate: z.any().optional(),   // Snapshot para el recibo
  position: z.string().optional(),
  department: z.string().optional(),
  
  baseAmount: z.number(), // Sueldo base calculado para el periodo
  
  // Detalle de conceptos
  earnings: z.array(z.object({
    concept: z.string(),
    amount: z.number(),
    isSalarial: z.boolean(),
  })),
  
  deductions: z.array(z.object({
    concept: z.string(),
    amount: z.number(),
  })),

  totalNet: z.number(),
  currency: z.enum(['USD', 'BS', 'EUR']),
  status: z.enum(['pending', 'paid', 'failed']).default('pending'),
});

export const PayrollCycleSchema = z.object({
  businessId: z.string(),
  name: z.string(), // Ej: "Primera Quincena - Junio 2026"
  
  startDate: z.any(),
  endDate: z.any(),
  paymentDate: z.any().optional(),
  
  status: PayrollCycleStatusSchema.default('draft'),
  
  // Tasa de cambio fijada para este ciclo (opcional, si no se usa la del momento)
  tasaOverride: z.number().optional(),

  // Totales del lote
  totalGross: z.number(),
  totalDeductions: z.number(),
  totalNet: z.number(),
  
  // Snapshot de los empleados y sus montos en este ciclo
  reports: z.array(PayrollEmployeeReportSchema),

  audit: AuditSchema,
});

export type PayrollCycle = z.infer<typeof PayrollCycleSchema>;
export type PayrollCycleWithId = PayrollCycle & { id: string };
export type PayrollEmployeeReport = z.infer<typeof PayrollEmployeeReportSchema>;
